import { Link, useNavigate } from "react-router-dom";
import { setAuthModalOpen } from "../../../redux/features/authModalSlice";
import { useDispatch } from "react-redux";
import bgPattern from "./bg-3.png";
import { useState } from "react";
import ProcessingBar2 from "../../../components/ProcessingBar/ProcessingBar2";

const ImageShapeGroup = () => {
  return (
    <div className="relative w-full max-w-2xl mx-auto" data-aos="fade-right">
      {/* Background pattern */}
      <div
        className="absolute inset-0 -z-10 bg-repeat opacity-80 rounded-3xl m-5"
        style={{ backgroundImage: `url(${bgPattern})` }}
      />
      <div className="grid grid-cols-2 gap-3 items-center">
        {/* Top Left Circular Image */}
        <div
          className="overflow-hidden h-36 w-full border-4 border-textGray mt-[-20px]"
          style={{ clipPath: "ellipse(50% 120% at 50% 100%)" }}
        >
          <img
            src="https://images.pexels.com/photos/705255/pexels-photo-705255.jpeg"
            alt="Chef"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Top Right Oval Image */}
        <div className="rounded-full overflow-hidden w-full h-50 sm:h-40 border-4 border-text">
          <img
            src="https://images.pexels.com/photos/3757942/pexels-photo-3757942.jpeg"
            alt="Salon"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Bottom Left Image */}
        <div
          className="rounded overflow-hidden w-full h-36 sm:h-40 col-span-2 lg:col-span-1 lg:mt-[20px] border-4 border-textGray"
          style={{ clipPath: "ellipse(50% 120% at 50% 0%)" }}
        >
          <img
            src="https://images.pexels.com/photos/29177202/pexels-photo-29177202/free-photo-of-middle-eastern-cuisine-with-hummus-and-crepes.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="Spa"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Decorative Line */}
      <img
        src="/images/shape/shape_150.svg"
        alt="decoration"
        className="absolute left-[-30px] top-[60%] w-20"
      />
      <img
        src="/images/shape/shape_151.svg"
        alt="decoration"
        className="absolute right-[0px] top-[60%] w-20"
      />
    </div>
  );
};

const SignUpBanner = () => {
  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };
  return (
    <div className="bg-black relative z-20 overflow-hidden py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Left - Images */}
        <ImageShapeGroup />

        {/* Right - Text */}
        <div className="flex-1 text-center lg:text-left" data-aos="fade-left">
          <h2 className="text-white text-4xl sm:text-5xl font-bold mb-6">
            Start Your Free Trial
          </h2>
          <p className="text-white text-base sm:text-lg mb-8 max-w-md mx-auto lg:mx-0">
            Enjoy full access to all features with a 30-day free trial.
          </p>
          <div className="flex gap-x-4">
            <button
              onClick={handleregister}
              className="bg-red-600 hover:bg-red-700 transition text-white text-sm py-2 px-6 rounded-full w-[150px] h-[40px]"
            >
              {showProcessing ? (
                <div className="flex items-center justify-center w-full h-full">
                  <ProcessingBar2 />
                </div>
              ) : (
                "Try Free Now"
              )}
            </button>
            <button
              onClick={handleBookACall}
              className="relative text-text text-sm font-semibold pb-0 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-text after:transition-all after:duration-200 hover:after:w-0 min-w-[100px] h-[40px] flex items-center justify-center"
            >
              {showProcessingCall ? <ProcessingBar2 /> : "Book a call"}
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Right Shape */}
      <div className="absolute bottom-0 right-0 w-32 h-32  bg-repeat opacity-5 pointer-events-none" />
    </div>
  );
};

export default SignUpBanner;
